<template lang="pug">
  #organization
    WtTile.mb-5(v-if="memberOrganizationNoticeLoaded && _.get(memberOrganizationNotice, 'id', false)" :is-loading="!organizationsLoaded")
      WtTile.is-paddingless(child :col="12")
        BNotification(
          type="is-lightgrey"
          aria-close-label="Close notice"
          @close="dismissNotice(memberOrganizationNotice.id)"
        )
          WtDisplayRichTextHTML(:html="memberOrganizationNotice.text")
    div.container
      WtTile.is-paddingless.is-flex.is-flex-direction-row.is-align-items-center(parent :col="12" :is-loading="!organizationsLoaded")
        BIcon.is-paddingless(
          icon="arrow-left mdi"
          type="is-primary"
        )
        WtButton.back-button.px-0(
          :isTextUnderlined="false"
          isText  
          isRouterLink
          :to="{ name: 'OrganizationsCenterSettings' }"
        ) Back
      WtTile(parent :col="12" :is-loading="!organizationsLoaded").is-paddingless
        WtTitle.org-title.is-size-2 {{_.get(coreProgramMeta, "organizationsName", "Organization")}}: {{ _.get(memberOrganization, "name", "") }}
        //- WtTile(
        //-   v-if="isOrganizationAdmin || $auth.user().isProgramAdmin"
        //-   parent
        //-   :col="12"
        //- )
        //-   WtTile(parent :col="12")
        //-     OrganizationAdminToolbar(
        //-       :organization="memberOrganization"
        //-       :notice="organizationNotice"
        //-       :noticeLoaded="organizationNoticeLoaded"
        //-     )  
      WtTile(parent :is-loading="!organizationsLoaded").is-paddingless.is-size-7.created-subtitle
        p Created {{ creationDateFormatted }}
      WtTile(:is-loading="!organizationsLoaded")
        OrganizationStats(
          :totalSteps="parseInt(_.get(memberOrganization, 'stepsAndActivities.data_steps', 0))"
          :totalActivities="parseInt(_.get(memberOrganization, 'stepsAndActivities.data_activities', 0))"
          :membersCount="_.get(memberOrganization, 'membersCount.membersCount', 0)"
        )
      WtTile(:is-loading="!organizationsLoaded")
        OrganizationTeams(
          :organizationId="_.get(memberOrganization, 'id', 0)"
          :perPage="8"
      )
    div.container
      WtTile(parent :col="12" :is-loading="!organizationsLoaded")
        OrganizationMembersNew(
          :organizationId="_.get(memberOrganization, 'id', 0)"
          :perPage="10"
          :membersCount="_.get(memberOrganization, 'membersCount.membersCount', 0)"
        )
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import OrganizationOverview from "@@/Organization/OrganizationOverview";
import OrganizationStats from "@@/Organization/OrganizationStats";
import OrganizationMembersNew from "@@/Organization/OrganizationMembersNew";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtButton from "@@/WtButton/WtButton";
import OrganizationChallenges from "@@/Organization/OrganizationChallenges";
import OrganizationTeams from "@@/Organization/OrganizationTeams.vue";

export default {
  name: "OrganizationPage",

  components: {
    OrganizationTeams,
    WtTitle,
    WtTile,
    WtRouterLink,
    OrganizationOverview,
    OrganizationStats,
    OrganizationMembersNew,
    WtDisplayRichTextHTML,
    WtButton,
    OrganizationChallenges
  },

  mixins: [dateUtilityMixin],

  computed: {
    ...mapGetters("members", [
      "member",
      "memberLoaded",
      "memberOrganizationNotice",
      "memberOrganizationNoticeLoaded"
    ]),
    ...mapGetters("organizations", [
      "memberOrganization",
      "organizations",
      "organizationsLoaded",
      "organizationChallenges",
      "organizationChallengesLoaded"
    ]),
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("notices", [
      "organizationNotice",
      "organizationNoticeLoaded"
    ]),

    creationDateFormatted() {
      let creationDate = this._.get(this.memberOrganization, "created", "");
      if (creationDate) {
        return this.date(Date.parse(creationDate), "DATE_FORMAT_SHORT_MONTH")
          .formatted;
      }
      return "";
    },

    routeOrganizationName() {
      return this.$route.params.organizationName;
    },

    isUserPartOfOrganization() {
      return (
        this.routeOrganizationName ===
        this._.get(this.member, "organizationData.name", 0)
      );
    },

    isOrganizationAdmin() {
      return (
        this.isUserPartOfOrganization &&
        this.member.id ===
          this._.get(this.member, "organizationData.adminId", 0)
      );
    }
  },

  watch: {
    memberLoaded() {
      if (this.memberLoaded && this.organizationsLoaded) {
        this.fetchMemberOrganizationData();
      }
    },
    organizationsLoaded() {
      if (this.memberLoaded && this.organizationsLoaded) {
        this.fetchMemberOrganizationData();
      }
    }
  },

  mounted() {
    if (this.memberLoaded && this.organizationsLoaded) {
      this.fetchMemberOrganizationData();
    }
  },

  methods: {
    ...mapActions("organizations", [
      "fetchOrganization",
      "setMemberOrganization",
      "fetchOrganizationMembers",
      "fetchOrganizationChallenges"
    ]),
    ...mapActions("notices", [
      "fetchOrganizationNotice",
      "dismissOrganizationNotice"
    ]),
    ...mapActions("members", ["fetchMemberOrganizationNotice"]),
    ...mapActions(["snackBar"]),

    fetchMemberOrganizationData: async function() {
      let orgId = 0;

      if (this.isUserPartOfOrganization) {
        orgId = this._.get(this.member, "organizationId", null);
      } else {
        orgId = this._.find(this.organizations, {
          name: this.routeOrganizationName
        }).id;
      }
      if (orgId) {
        const organization = await this.fetchOrganization({
          organizationId: orgId,
          relations: ["membersCount", "stepsAndActivities"]
        });
        this.setMemberOrganization(organization);
        if (!this.organizationNoticeLoaded) {
          await this.fetchOrganizationNotice({
            organizationId: orgId,
            programId: this.memberOrganization.programId
          });
        }
        if (!this.memberOrganizationNoticeLoaded) {
          await this.fetchMemberOrganizationNotice({
            memberId: this.$auth.user().id
          });
        }
        if (!this.organizationChallengesLoaded) {
          await this.fetchOrganizationChallenges({
            organizationId: orgId
          });
        }
      }
      if (!this.memberOrganization.active) {
        this.snackBar({
          indefinite: true,
          type: "is-danger",
          message:
            "Your organization is no longer active, please contact your program administrator."
        });
      }
    },
    dismissNotice(noticeId) {
      this.dismissOrganizationNotice(noticeId);
    }
  }
};
</script>

<style lang="sass" scoped>
#organization
  .back-button
    background-color: $white-ter
  .org-title.is-size-2
    font-family: Manrope !important
    font-weight: 550
    line-height: 36px
  .created-subtitle
    font-family: Manrope !important
    font-weight: 400
    line-height: 20px
    padding-top: 0 !important
</style>
